import { useState } from 'react';
import Button from '../../../components/base/Button';

export default function TestimonialSection() {
  const [showAllMobile, setShowAllMobile] = useState(false);
  
  const testimonials = [
    {
      name: 'Ken Gitz',
      role: 'Business Owner',
      quote: 'Best gym in eldoret this is a state of art gym!',
      rating: 5
    },
    {
      name: 'Moureen Tulia',
      role: 'Teacher',
      quote: 'HFC Gym it\'s the best place to train in Eldoret. They have affordable subscription fees, well equipped with quality machines, welcoming staff and professional trainers,, a must place to visit',
      rating: 5
    },
    {
      name: 'Fergus Wood',
      role: 'Software Developer',
      quote: 'Possibly the best gym I\'ve been to home or away (live in London). Day pass is 500KSH so good value too!',
      rating: 5
    },
    {
      name: 'Moses Kimathi',
      role: 'Nurse',
      quote: 'Modern equipment, excellent trainer trainee relations, wonderful ambiance, and aura',
      rating: 5
    },
    {
      name: 'Henatal Mugala',
      role: 'Entrepreneur',
      quote: 'Looking for a place to start your fitness journey then you\'ve just arrived at the right place',
      rating: 5
    },
    {
      name: 'Sarah Huwel',
      role: 'Marketing Manager',
      quote: 'Allahibarik mashallah this is an outstanding international gym, it has brand new equipment with amazing trainers. It also has good space for cardio work and separate space for body building, definitely the best in Eldoret',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-6 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-4 lg:mb-16">
          <div className="inline-block px-2 py-1 lg:px-4 lg:py-2 bg-red-100 text-red-700 rounded-lg text-[10px] lg:text-sm font-bold mb-1.5 lg:mb-4 uppercase tracking-wider">
            SUCCESS STORIES
          </div>
          <h3 className="text-xl lg:text-6xl font-black text-gray-900 mb-1.5 lg:mb-6">
            Real Members, Real <span className="text-red-600">Results</span>
          </h3>
          <p className="text-[10px] lg:text-xl text-gray-600 max-w-3xl mx-auto hidden lg:block">
            Join hundreds of members who have transformed their lives at HFC Gym Eldoret
          </p>
        </div>

        {/* Stats Bar */}
        <div className="grid grid-cols-4 gap-1 lg:gap-6 mb-4 lg:mb-16">
          <div className="text-center p-1.5 lg:p-6 bg-gradient-to-br from-red-50 to-orange-50 rounded-lg lg:rounded-2xl">
            <div className="text-base lg:text-4xl font-black text-red-600 mb-0">500+</div>
            <div className="text-gray-700 font-semibold text-[8px] lg:text-base">Members</div>
          </div>
          <div className="text-center p-1.5 lg:p-6 bg-gradient-to-br from-red-50 to-orange-50 rounded-lg lg:rounded-2xl">
            <div className="text-base lg:text-4xl font-black text-red-600 mb-0">4.9/5</div>
            <div className="text-gray-700 font-semibold text-[8px] lg:text-base">Rating</div>
          </div>
          <div className="text-center p-1.5 lg:p-6 bg-gradient-to-br from-red-50 to-orange-50 rounded-lg lg:rounded-2xl">
            <div className="text-base lg:text-4xl font-black text-red-600 mb-0">100+</div>
            <div className="text-gray-700 font-semibold text-[8px] lg:text-base">Machines</div>
          </div>
          <div className="text-center p-1.5 lg:p-6 bg-gradient-to-br from-red-50 to-orange-50 rounded-lg lg:rounded-2xl">
            <div className="text-base lg:text-4xl font-black text-red-600 mb-0">Pro</div>
            <div className="text-gray-700 font-semibold text-[8px] lg:text-base">Trainers</div>
          </div>
        </div>

        {/* Testimonials Grid - Show only 2 on mobile by default */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-2 lg:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className={`bg-gradient-to-br from-gray-50 to-white rounded-lg lg:rounded-3xl p-2.5 lg:p-8 shadow-lg hover:shadow-xl transition-all duration-500 hover:-translate-y-2 flex flex-col ${
                !showAllMobile && index >= 2 ? 'hidden lg:flex' : ''
              }`}
            >
              {/* Header */}
              <div className="flex items-start gap-1.5 lg:gap-4 mb-1.5 lg:mb-6">
                <div className="flex-1">
                  <h4 className="text-xs lg:text-xl font-bold text-gray-900 mb-0 lg:mb-1">
                    {testimonial.name}
                  </h4>
                  <div className="flex items-center gap-0.5 lg:gap-1">
                    {[...Array(5)].map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-[8px] lg:text-sm ${
                          i < testimonial.rating ? 'text-red-600' : 'text-gray-300'
                        }`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>

              {/* Quote */}
              <p className="text-gray-700 leading-relaxed italic text-[10px] lg:text-base line-clamp-2 lg:line-clamp-none">
                "{testimonial.quote}"
              </p>
            </div>
          ))}
        </div>

        {/* View More Button - Mobile Only */}
        {!showAllMobile && (
          <div className="lg:hidden text-center mt-3">
            <Button
              onClick={() => setShowAllMobile(true)}
              variant="primary"
              icon="ri-arrow-down-s-line"
              iconPosition="right"
              className="text-[10px] px-4 py-2"
            >
              View More Reviews
            </Button>
          </div>
        )}
      </div>
    </section>
  );
}
